import { render } from "./Index.vue?vue&type=template&id=754dd301&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=754dd301&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754dd301"],['__file',"src/assets/js/pages/AddGate/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "754dd301"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('754dd301', __exports__)) {
    api.reload('754dd301', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=754dd301&scoped=true", () => {
    api.rerender('754dd301', render)
  })

}


export default __exports__